import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateVoteHeadForm from "../../forms/CreateOrUpdateVoteHeadForm";

interface CreateVoteHeadModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateVoteHeadModal: React.FC<CreateVoteHeadModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create New Vote Head"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateVoteHeadForm loading={loading} error={error} />
  </AppModal>
);

export default CreateVoteHeadModal;
